import { Component, OnInit, ViewChild } from '@angular/core';
import { EventService } from "../../core/services/event.service";
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Device } from '@capacitor/device';
import { Platform } from '@angular/cdk/platform';
import { AuthService } from '../../core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { LinkModalComponent } from '../../shared/components/link-modal/link-modal.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-photowall-eventlist',
  templateUrl: './photowall-eventlist.component.html',
  styleUrls: ['./photowall-eventlist.component.css']
})

export class PhotowallEventlistComponent implements OnInit {

  displayedColumns: string[] = ['name', 'date', 'send-notification'];
  //dataSource = new MatTableDataSource<any>();
  dataSource = new MatTableDataSource([]);
  isLoading!: boolean;

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  events: any;
  confirmMessage = "'Are you sure you want to delete the selected file(s)?'"
  showConfirmModal = false;
  selectedId: any;
  userUrl: any;
  userId: any;

  constructor(public dialog: MatDialog,
    private location: Location,
    private authService: AuthService,
    private router: Router,private route: ActivatedRoute,
    private platform: Platform, private eventService: EventService) { }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: any) {
    let inputTarget = filterValue.value;
    inputTarget = inputTarget.trim(); // Remove whitespace
    inputTarget = inputTarget.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = inputTarget;
  }

  addBranding(event: any) {
    // console.log(event); //__CONSOLE_LOG__ //__CONSOLE_LOG__
    localStorage.setItem('e', event.id);
    localStorage.setItem('name', event.name);
    localStorage.setItem('branding', event.branding == 1 ? 'true' : 'false');
    this.router.navigate(['add-branding']);
  }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    (await (this.eventService.getEventList())).subscribe({
      next: (res: any) => {
        // console.log(res); //__CONSOLE_LOG__
        this.isLoading = false;
        if (res) {
          // Convert start_time to Date for each event
          const formattedData = res.map((event: any) => ({
            ...event,
            start_time: new Date(event.start_time), // Convert start_time to Date
          }));

          // console.log(formattedData) //__CONSOLE_LOG__
          this.userId = res[0].host_id;
          this.dataSource.data = formattedData;
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
      }
    });

  }

  logout() {
    this.authService
      .signOut()
      .then((res) => {
        this.router.navigateByUrl(
          "/auth/login"
        );
      })
      .catch((err) => {
        // console.error(err); //__CONSOLE_LOG__
      });
  }

  goBack() {
    //localStorage.removeItem('eventId');
    this.location.back();
  }

  wallSettings(event: any) {
    // console.log(event); //__CONSOLE_LOG__
    localStorage.setItem('e', event.id);
    localStorage.setItem('name', event.name);
    this.router.navigateByUrl('/photowall-configuration');
  }

  async sendNotification(event_id: any) {
    this.isLoading = true;
    (await (this.eventService.sendNotification(event_id))).subscribe({
      next: (res: any) => {
        // console.log(res); //__CONSOLE_LOG__
        this.isLoading = false;
      }
    });
  }

  async downloadApp() {
    const info = await Device.getInfo();
    // console.log(info, this.platform); //__CONSOLE_LOG__

    if (this.platform.IOS && info.model === 'iPhone' && info.platform === 'web') {
      window.location.href = 'https://apps.apple.com/in/app/picaggo/id1527686260';
    }

    if (this.platform.ANDROID && info.platform === 'web') {
      window.location.href = 'https://play.google.com/store/apps/details?id=application.share.photo.picaggo';
    }


    if (!this.platform.ANDROID && !this.platform.IOS && info.platform === 'web') {
      window.location.href = 'https://picaggo.com';
    }
  }

}
